/**
 * Module definition houses global application services
 *
 * @module services
 */
angular.module('services', [
  'services.endpoints',
  'services.error',
  'services.newman',
  'services.delivery',
  'services.utility'
]);
